import * as yup from 'yup';

import { createHighestRateValidation, createLowestRateValidation } from 'src/utils/validations';

import { TRIPLE_TOGGLE_PRICING_TYPES } from '../components/ThreeToggleRates';
import { COMMERCIAL_CARDS, OTHER_CARDS, PERSONAL_CARDS } from '../sections/TransactionPricing';

const PER_ITEM_VALIDATION = yup.number().when('type', (type: string, schema: yup.NumberSchema) => {
    return ['BOTH', 'PER_ITEM'].includes(type) ? schema.required() : schema.notRequired();
});

const PERCENTAGE_VALIDATION = yup
    .number()
    .when('type', (type: string, schema: yup.NumberSchema) => {
        return ['BOTH', 'PERCENTAGE'].includes(type) ? schema.required() : schema.notRequired();
    });

export const TRIPLE_TOGGLE_VALIDATION = yup.object().shape({
    type: yup
        .string()
        .oneOf(
            TRIPLE_TOGGLE_PRICING_TYPES.map((item: { value: string }) => {
                return item.value;
            })
        )
        .required(),
    baseRate: yup.number(),
    percentageBaseRate: yup.number().when('type', (type: string, schema: yup.NumberSchema) => {
        return type === 'PERCENTAGE' ? schema.required() : schema;
    }),
    percentageLowestRate: PERCENTAGE_VALIDATION.test(
        'lowest-rate-validation',
        'Lowest rate cannot exceed highest rate',
        createLowestRateValidation('percentageLowestRate', 'percentageHighestRate')
    ),
    percentageHighestRate: PERCENTAGE_VALIDATION.test(
        'highest-rate-validation',
        'Highest rate cannot be less than lowest rate',
        createHighestRateValidation('percentageLowestRate', 'percentageHighestRate')
    ),
    perItemBaseRate: PER_ITEM_VALIDATION,
    perItemLowestRate: PER_ITEM_VALIDATION.test(
        'lowest-rate-validation',
        'Lowest rate cannot exceed highest rate',
        createLowestRateValidation('perItemLowestRate', 'perItemHighestRate')
    ),
    perItemHighestRate: PER_ITEM_VALIDATION.test(
        'highest-rate-validation',
        'Highest rate cannot be less than lowest rate',
        createHighestRateValidation('perItemLowestRate', 'perItemHighestRate')
    ),
    baseRatePercentage: yup.number().when('type', {
        is: 'BOTH',
        then: (schema: yup.NumberSchema) => {
            return schema.required();
        },
        otherwise: (schema: yup.NumberSchema) => {
            return schema.notRequired();
        },
    }),
});

export const TRANSACTION_PRICING_VALIDATION = () => {
    let personalCards,
        commercialCards,
        otherCards = {};

    PERSONAL_CARDS.forEach(({ name }: { name: string }) => {
        personalCards = {
            ...personalCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    COMMERCIAL_CARDS.forEach(({ name }: { name: string }) => {
        commercialCards = {
            ...commercialCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    OTHER_CARDS.forEach(({ name }: { name: string }) => {
        otherCards = {
            ...otherCards,
            [name]: TRIPLE_TOGGLE_VALIDATION,
        };
    });
    return {
        personalCards: yup.object().shape(personalCards),
        commercialCards: yup.object().shape(commercialCards),
        otherCards: yup.object().shape(otherCards),
    };
};
